exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".react-components-shared-borderForChangedValue-index__changedValue--2AGClyz5MF {\n  border: 2px solid #00a3f5;\n  -webkit-border-radius: 5px;\n     -moz-border-radius: 5px;\n          border-radius: 5px;\n  margin-bottom: 10px;\n  max-width: -webkit-max-content;\n  max-width: -moz-max-content;\n  max-width: max-content;\n  padding: 2px;\n}", ""]);

// Exports
exports.locals = {
	"changedValue": "react-components-shared-borderForChangedValue-index__changedValue--2AGClyz5MF"
};